<!-- 流量计累计值查询 -->
<template>
  <div class="nx-list-page">
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    />
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { searchTimeConfig } from "@/basic-common/util/common";
import { getSettingDate } from "@/util/date";
import { getList } from "./api";

function formatDateTime(val) {
  if (val == null || val === "") return "-";
  if (val instanceof Date && !Number.isNaN(val.getTime())) {
    const pad = (n) => String(n).padStart(2, "0");
    return `${val.getFullYear()}-${pad(val.getMonth() + 1)}-${pad(val.getDate())} ${pad(val.getHours())}:${pad(val.getMinutes())}:${pad(val.getSeconds())}`;
  }
  return String(val);
}

export default {
  name: "FlowMeterSnapshot",
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: { getList },
      option: {
        ...this.$store.state.publicOption,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        menu: false,
        column: [
          {
            label: "流量计编码",
            prop: "meterCode",
            search: true,
            width: 150
          },
          {
            label: "流量计名称",
            prop: "meterName",
            search: true,
            width: 160
          },
          {
            label: "正向累计",
            prop: "positiveTotal",
            width: 130,
            align: "right"
          },
          {
            label: "反向累计",
            prop: "reverseTotal",
            width: 130,
            align: "right"
          },
          {
            label: "净累计",
            prop: "netTotal",
            width: 130,
            align: "right"
          },
          {
            label: "外部采集时间",
            prop: "collectTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            width: 170,
            formatter: (row) => formatDateTime(row.collectTime)
          },
          {
            label: "服务端接收时间",
            prop: "receiveTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            width: 170,
            formatter: (row) => formatDateTime(row.receiveTime)
          },
          {
            label: "推送来源IP",
            prop: "pushIp",
            width: 140
          },
          {
            label: "原始报文",
            prop: "rawJson",
            hide: true,
            overHidden: true,
            width: 260
          },
          {
            ...searchTimeConfig,
            label: "接收时间",
            paramsKey: ["startTime", "endTime"],
            searchValue: [getSettingDate("daySLast30"), getSettingDate("dayE")]
          }
        ]
      }
    };
  }
};
</script>
